import { rnd, useModulesContext } from './ModulesContext';
import { getModuleX, MAX_WIDTH, MODULE_WIDTH } from './Content';
import { useMemo } from 'react';

const MODULE_START_PERCENTAGE = (140 - MAX_WIDTH) / 2 + MODULE_WIDTH / 2;
const MAX_WIDTH_MIN_PADDING = MAX_WIDTH - MODULE_WIDTH;

const getFlash = (
    totalModules: number,
    i: number,
    key: string,
    y: number,
    eventBegin: number,
    eventDuration: number
) => ({
    cx: getModuleX(totalModules, i) + MODULE_WIDTH / 2 + '%',
    cy: y + 1 + '%',
    factor: (rnd(7) + 3) / 10,
    key,
    begin:
        eventBegin +
        Math.round(
            (eventDuration *
                (MODULE_START_PERCENTAGE + (totalModules - i - 1) * (MAX_WIDTH_MIN_PADDING / totalModules))) /
                140
        ) +
        'ms'
});

export const Flashes = () => {
    const { events, modulesArray } = useModulesContext();

    const flashes = useMemo(() => {
        return events.flatMap((e) => {
            return modulesArray.flatMap((m, i) => {
                if (m.isDisabled) return [];

                return [getFlash(modulesArray.length, i, `${e.id}-${m.key}`, e.y, e.begin, e.duration)];
            });
        });
    }, [events]);

    return (
        <g>
            {flashes.map((f, i) => (
                <ellipse
                    rx={10 * f.factor}
                    ry={25 * f.factor}
                    stroke="#FFBE01"
                    strokeWidth="2"
                    transform="scale(0)"
                    transform-origin="center"
                    cx={f.cx}
                    cy={f.cy}
                    key={i}>
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="scale"
                        from="1"
                        to="0"
                        begin={f.begin}
                        dur="200ms"
                        fill="freeze"
                    />
                </ellipse>
            ))}
        </g>
    );
};
